"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDesignObjectFilterSchema = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const QueryBuilder_1 = require("../QueryBuilder");
const designObjectTypeValues = { ...sigma_engine_shared_1.DesignObjectType };
exports.buildDesignObjectFilterSchema = (0, QueryBuilder_1.createFilterSchema)({
    fields: {
        type: {
            options: {
                type: QueryBuilder_1.FieldType.String,
                values: designObjectTypeValues,
                nonNullable: true,
            },
            allowedOperators: ['equals', 'is', 'doesNotEqual', 'not', 'isAnyOf', 'isNoneOf'],
            description: 'DesignObject category — net | module | component | netconn | custom.',
        },
        net: {
            options: { type: QueryBuilder_1.FieldType.String },
            description: 'Net name.',
        },
        module: {
            options: { type: QueryBuilder_1.FieldType.String },
            description: 'Module path.',
        },
        component: {
            options: { type: QueryBuilder_1.FieldType.String },
            description: 'Component reference designator.',
        },
        signal: {
            options: { type: QueryBuilder_1.FieldType.String },
            description: 'Component signal pin name.',
        },
        customTypeName: {
            options: { type: QueryBuilder_1.FieldType.String },
            description: "Custom subject type name (e.g. 'cadstrom.bus'); only on custom rows.",
        },
        subjectName: {
            options: { type: QueryBuilder_1.FieldType.String },
            description: 'Custom subject display name; only on custom rows.',
        },
    },
});
//# sourceMappingURL=build-design-object-filter-schema.js.map